import { SuspiciousTransactions } from './SuspiciousTransactions';

export default SuspiciousTransactions;
